// Auto-generated - do not edit manually
export { BaseIcon } from "./BaseIcon";
export type {
  CurrencyIconProps,
  CurrencyIconComponent,
  IconVariant,
} from "./types";

export { GreenOrb } from "./components/GreenOrb";
export { LoyaltyPoint } from "./components/LoyaltyPoint";
export { PlayTime } from "./components/PlayTime";
export { XsollaGold } from "./components/XsollaGold";
export { XsollaPoint } from "./components/XsollaPoint";
export { XsollaTicket } from "./components/XsollaTicket";
export { XsollaZk } from "./components/XsollaZk";
